import staffManager from "staff";
const staff = staffManager.api;
export default staff;
